export default function Vision() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              OUR VISION
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Shaping the Future of Pharmaceutical Care
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              We envision a world where every patient has access to high-quality, affordable cardiac and diabetic medicines, and where healthcare providers can trust in the efficacy and safety of the products they prescribe.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Our vision extends beyond just providing medicines. We aim to be a catalyst for positive change in the pharmaceutical industry, setting new standards for quality, innovation, and patient care.
            </p>

            <div className="space-y-6">
              <div className="bg-gradient-to-r from-cyan-50 to-teal-50 p-6 rounded-2xl">
                <div className="flex items-center mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-cyan-600 rounded-lg mr-3">
                    <i className="ri-lightbulb-line text-white text-lg"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">Innovation Leadership</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  To be recognized as a leader in pharmaceutical innovation, continuously improving our product portfolio and distribution networks.
                </p>
              </div>

              <div className="bg-gradient-to-r from-teal-50 to-cyan-50 p-6 rounded-2xl">
                <div className="flex items-center mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-lg mr-3">
                    <i className="ri-team-line text-white text-lg"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">Strategic Partnerships</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  To build strong, lasting partnerships with healthcare providers, hospitals, and medical institutions across the globe.
                </p>
              </div>

              <div className="bg-gradient-to-r from-cyan-50 to-teal-50 p-6 rounded-2xl">
                <div className="flex items-center mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-cyan-600 rounded-lg mr-3">
                    <i className="ri-earth-line text-white text-lg"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">Sustainable Growth</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  To achieve sustainable growth while maintaining our commitment to quality, ethics, and social responsibility.
                </p>
              </div>
            </div>
          </div>

          <div>
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/assets/AboutVision.jpg"
                alt="Our Vision"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
